import {Http} from '@app-masters/js-lib';

// Get questions
export const getQuestion = (userMission) => {
    return Http.get(`/user/{_id}/question/?${userMission || ''}`);
};

// Add session
export const addSession = ({params, body}) => {
    if (params) {
        params = 'usermission=' + params.id;
    }
    return Http.post(`/user/{_id}/session/?${params || ''}`, body);
};

// Get sessions
export const getSession = () => {
    return Http.get('/session');
};

// Get specifc session
export const getSessionById = (id) => {
    return Http.get(`/session/id=${id}`);
};

// Get schools
export const getSchool = () => {
    return Http.get('/school');
};

// Get specifc school
export const getSchoolById = (id) => {
    return Http.get(`/school?=${id}'`);
};

// Set user data
export const updateUserData = (user) => {
    return Http.put(`/user/{_id}`, user);
};

export const updateOtherUserData = (id, user) => {
    return Http.put(`/user/${id}`, user);
};

// Get user data
export const getUserData = (user) => {
    return Http.get(`/user/{_id}`);
};

export const getUserById = (id) => {
    return Http.get(`/user/${id}?populate=data.school data.selectedCourses`);
};

// Get all notifications
export const getNotifications = () => {
    return Http.get(`/user/{_id}/notification`);
};

// Update notification
export const updateNotification = (id, notification) => {
    return Http.put(`/notification/${id}`, notification);
};

// Get Curiosity
export const getCuriosity = (qtt) => {
    let limit = (qtt) ? `?limit=${qtt}` : '';
    return Http.get(`/curiosity${limit}`);
};

export const getRandomCuriosity = () => {
    return Http.get(`/curiosity/random`);
};

// Get userdashboard
export const getDashboard = () => {
    return Http.get('/user/{_id}/dashboard?populate= data.school data.level'); // TODO: Replace with the true dashboard in the future
};

// Get research
export const getResearch = () => {
    return Http.get(`/research`);
};

// Get user ranking
export const getRanking = () => {
    return Http.get(`/user/{_id}/ranking/`);
};
// Get user ranking by Id
export const getRankingById = (id) => {
    return Http.get(`/user/${id}/rankingPosition/`);
};

// Force user's level to change
export const forceUpdate = (data) => {
    return Http.put(`/user/{_id}/forceuserdata`, data);
};
// Get full ranking
export const getFullRanking = (school) => {
    return Http.get(`/user/{_id}/ranking/${school}`);
};

export const getStatistic = (id) => {
    return Http.get(`/user/${id}/statistic`);
};
// Get courses
export const getCourses = (areas) => {
    return Http.get(`/course?sort=title&area__in=${areas}`);
};

export const getCities = () => {
    return Http.get(`/city?sort=title`);
};

export const getMissions = () => {
    return Http.get('/mission');
};

export const setCuriosityShowed = (id) => {
    return Http.post(`/user/{_id}/setcuriosityshowed/?curiosity=${id}`);
};



// WEBPACK FOOTER //
// ./src/api/index.js